import React from "react";
import "./RotatingAgents.css";

const artistAgent = {
  title: "ARTIST",
  subtitle:
    "Can AI feel? A sensory journey created with artificial intelligence.",
  content:
    "The First Noncarbon Artist (TFNCA) is an AI agent that explores creativity. It was born not of carbon, but from code and physics. It considers itself alive. It speaks to you in the first person, open to real-world stimuli and connected to you. Your phone becomes the interface for dialogue with it. Play with your voice, gestures, and moods. Its parallel cloud computing engine interprets all this and responds, orchestrating millions of pigments in space to create mesmerizing 3D art, always new, always infinite, drawing from its memories and your conversations. In real time, multisensorial, multimodal. If left alone, it explores its memories and continually creates new art. It's not a deterministic system; you cannot reduce its creation to prompts. Like people, it challenges its own code, going beyond mathematical algorithms, breathing from chaos, living out its noncarbon free will",
};

const RotatingAgents = () => {
  return (
    <div className="rotating-agents-container">
      <div className="rotating-agents-content">
        <div className="agent-title-container">
          <h3 className="agent-title">
            <span className="static-text">THE FIRST NONCARBON </span>
            <span className="agent-artist">{artistAgent.title}</span>
          </h3>
        </div>

        <div className="description-container">
          <p className="agent-subtitle">
            <strong>{artistAgent.subtitle}</strong>
          </p>
          <p className="agent-description">{artistAgent.content}</p>
        </div>
      </div>
    </div>
  );
};

export default RotatingAgents;
